// extracted by mini-css-extract-plugin
export default {"text":"styles_text__rXaZt","time":"styles_time__DVhck"};